<template>
  <div class="partners-main">
    <div v-if="!isPartner" class="partners-blur-view"/>
    <div class="partner-card-view">
      <PartnerIdentityCard></PartnerIdentityCard>
      <PartnerEarning></PartnerEarning>
      <PartnerPercentage />
    </div>
    <PartnerGraph />
    <PartnerHistory/>
  </div>
</template>

<script>
import PartnerIdentityCard from "../../../components/user/partners/PartnerIdentityCard";
import PartnerEarning from "../../../components/user/partners/PartnerEarnings";
import PartnerPercentage from "../../../components/user/partners/PartnerPercentage";
import PartnerGraph from "../../../components/user/partners/PartnerGraph";
import PartnerHistory from '../../../components/user/partners/PartnerHistory'
// apis
import { handleGetPartnerDetails } from "../../../service/partner";
export default {
  components: {
    PartnerIdentityCard,
    PartnerEarning,
    PartnerPercentage,
    PartnerGraph,
    PartnerHistory
  },
  data(){
    return {
      isPartner: false
    }
  },
  async mounted() {
    try {
      const res = await handleGetPartnerDetails();
      this.isPartner = res.data.data.isPartner;
    } catch (e) {
      console.log(e);
    }
  },
};
</script>

<style scoped>
.partner-card-view {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.partners-main {
  display: flex;
  flex-direction: column;
  position: relative;
}

.partners-blur-view {
  position: absolute;
  z-index: 10;
  height: 100%;
  width: 100%;
  border-radius: 15px;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.1);
}

@media only screen and (max-width: 1250px) {
  .partner-card-view {
    flex-wrap: wrap !important;
    justify-content: first baseline;
  }
  .partner-link-card,
  .partner-earning-card,
  .partner-percentage-card {
    max-width: 44% !important;
    width: 44% !important;
    flex: 44% !important;
    margin-bottom: 32px !important;
  }
}

@media only screen and (max-width: 665px) {
  .partner-link-card,
  .partner-earning-card,
  .partner-percentage-card {
    max-width: 100% !important;
    width: 100% !important;
    flex: 100% !important;
    margin-bottom: 32px !important;
  }
}
</style>
